
import request from '@/utils/request'
import global from '@/Global'
import axios from 'axios'

// 获取工作计划数据
export function getProcessListData(id, taskApproverId) {
  return request({
    url: global.api + '/process/getValue1',
    method: 'get',
    params: {
      id,
      taskApproverId
    }
  })
}

// 提交的审批
export function mySubmitList(params) {
  return request({
    url: global.api + '/process/listApprover',
    method: 'get',
    params: params
  })
}

// 待审批的
export function waitProcessList(params) {
  return request({
    url: global.api + '/process/listActivatedPerson',
    method: 'get',
    params: params
  })
}

// 已审批的
export function alreadyProcessList(params) {
  return request({
    url: global.api + '/process/listOnceApproved',
    method: 'get',
    params: params
  })
}
// 未提交
export function unSubmittedProcessList(params) {
  return request({
    url: global.api + '/workPlan/list2',
    method: 'get',
    params: params
  })
}
// 获取任务列表
export function getTasks(params) {
  return request({
    url: global.api + '/process/getTask',
    method: 'get',
    params: params
  })
}

// 读取单个供应商的信息
export function getSupplierInfo(params) {
  return request({
    url: global.api + '/process/getValue3',
    method: 'get',
    params: params
  })
}

// 提交人员审批
export function approvalAuthorSupplier(params) {
  return request({
    url: global.api + '/process/approval3',
    method: 'post',
    data: params
  })
}
// 消息中心
export function getCountAllType() {
  return request({
    url: global.api + '/process/countAllType',
    method: 'post'
  })
}

// 提交业务授权
export function approvalBusiness(params) {
  return request({
    url: global.api + '/process/approval8',
    method: 'post',
    data: params
  })
}
// 查看物质期间核查
export function viewMaterialVerification(params) {
  return request({
    url: global.api + '/process/getValue5',
    method: 'get',
    params: params
  })
}
// 审核物质期间核查
export function approvalMaterialVerification(params) {
  return request({
    url: global.api + '/process/approval5',
    method: 'post',
    data: params
  })
}
// 查看年度供应商
export function viewAnnualSupplier(params) {
  return request({
    url: global.api + '/process/getValue6',
    method: 'get',
    params: params
  })
}
// 审核年度供应商
export function approvalAnnualSupplier(params) {
  return request({
    url: global.api + '/process/approval6',
    method: 'post',
    data: params
  })
}
// 查看供应商审核
export function applidlist(params) {
  return request({
    url: global.api + '/supplier/applidlist',
    method: 'get',
    params: params
  })
}

// 提交审核供应商的文件
export function submitAnnualSupplierFiles(params) {
  return request({
    url: global.api + '/supplier/uploadFiles',
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 提交的审批
export function mySubmitExternalList(params) {
  return request({
    url: global.api + '/process/listApprover',
    method: 'get',
    params: params
  })
}

// 待审批的
export function waitProcessExternaList(params) {
  return request({
    url: global.api + '/process/listActivatedPerson',
    method: 'get',
    params: params
  })
}

// 已审批的
export function alreadyProcessExternaList(params) {
  return request({
    url: global.api + '/process/listOnceApproved',
    method: 'get',
    params: params
  })
}

// 获取当前人员的所有职位
export function getEmployeeList(params) {
  return request({
    url: global.api + '/employees/getEmployee2',
    method: 'get',
    params: params
  })

}
// 获取当前人员的所有职位
export function getAllProcessInfo(params) {
  return request({
    url: global.api + '/process/listAll',
    method: 'get',
    params: params
  })

}



// WEBPACK FOOTER //
// ./src/api/process/process.js